import { CheckCircleFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { SuccessColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconCheckCircleSuccess: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return (
        <CheckCircleFilled
            {...props}
            type="check-circle"
            style={{ ...props.style, color: SuccessColor }}
        />
    );
};
